import React from 'react';
import { Alert, Button } from 'react-bootstrap';

const renderDeleteConfirmation = (name, isDeleting, deleteHandler, dismissHandler, t) => {
  return (
    <Alert bsStyle="danger" onDismiss={() => dismissHandler()}>
      <p>{t('do you want to delete')} {name}?</p>
      <p>
        <Button
          onClick={() => deleteHandler()}
          bsStyle="danger"
          disabled={isDeleting}
        >
          {isDeleting ? `${t('deleting')}...` : t('delete')}
        </Button>
        <span> {t('or')} </span>
        <Button onClick={() => dismissHandler()} disabled={isDeleting}>
          {t('hide')}
        </Button>
      </p>
    </Alert>
  );
};

export default renderDeleteConfirmation;



// WEBPACK FOOTER //
// ./src/components/member/DeleteConfirmation.js